import { isEmpty, startsWith, extend } from 'lodash';
import debug from 'debug';
import axios from 'axios';
const log = debug('itp:core:downloads');
export function getFileBLOB(href, fileName, options) {
    let f = fileName || getFilenameFromURL(href) || '';
    log('getFileBlob: url=%s, filename=%s', href, f);
    if (!f) {
        return;
    }
    f = normalizeFileName(f);
    const config = options || {};
    extend(config, { responseType: 'arraybuffer' });
    return axios.get(href, config).then(response => {
        let fileName = extractFilenameFromContentDisposition(response);
        if (fileName == null) {
            fileName = f;
        }
        return {
            file: new File([response.data], f, {
                type: response.headers['content-type']
            }),
            fileName
        };
    });
}
export function normalizeFileName(filename) {
    return filename.replace('\\', '-').replace('/', '-');
}
export function getFilenameFromURL(url) {
    if (!url) {
        return;
    }
    const parts = url.split('/');
    return parts.pop() || parts.pop();
}
export function normalizeLink(url) {
    if (url == null || isEmpty(url)) {
        return;
    }
    if (startsWith(url, '#')) {
        return url;
    }
    const loc = location, u = new URL(url);
    if (u.host === loc.host && u.protocol !== loc.protocol) {
        u.protocol = loc.protocol;
        return decodeURIComponent(u.toString());
    }
    return url;
}
export function extractFilenameFromContentDisposition(response) {
    const disposition = response.headers['content-disposition'];
    let result;
    if (disposition) {
        result = extractFileName(disposition);
    }
    log('extractFilenameFromContentDisposition: `%s`; result=`%s`', disposition, result);
    return result;
}
function extractFileName(disposition) {
    const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
    if (utf8FilenameRegex.test(disposition)) {
        return decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
    }
    const filenameStart = disposition.toLowerCase().indexOf('filename=');
    if (filenameStart == -1) {
        return;
    }
    const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
    const partialDisposition = disposition.slice(filenameStart);
    const matches = asciiFilenameRegex.exec(partialDisposition);
    if (matches != null && matches[2]) {
        return matches[2];
    }
}
//# sourceMappingURL=helpers.js.map